import React, { useState } from "react";
import axios from "axios";


const useSystemHoliday = ({
    onFinish = ({ axiosMode, status, values }) => { }, //
    onBefore = ({ axiosMode, status }) => { }, //
}) => {
    const mainApi = `/hrms/api/holiday/setting`
    const [data, setData] = useState([])
    const [newYearData,setNewYearData] =useState({
        data:[],
        total:0,
        year:2000
    })
    const getSystemHolidaySettingData = ({
        cur_page,
        size,
        custom_filter_value,
        custom_filter_key,
    }) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: {
                cur_page,
                size,
                custom_filter_value,
                custom_filter_key,
            },
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            values: {
                                data: [],
                                total: 0
                            }
                        }
                    )
                }
                return {
                    ...data
                }
            });
    }
    const getSystemHolidaySettingNewYear= () => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/hrms/api/holiday/new_year', {
            
        })
            .then((response) => {
                let data = response.data
                setNewYearData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            values: data
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            values: {
                                data: [],
                                total: 0
                            }
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postSystemHolidaySettingData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/hrms/api/holiday/new_year',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                    
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })
    }
    const patchSystemHolidaySettingData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteSystemHolidaySettingData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                    
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        systemHolidaySettingDatas: data,
        systemHolidaySettingNewYearDatas: newYearData,
        getSystemHolidaySettingNewYear,
        getSystemHolidaySettingData,
        postSystemHolidaySettingData,
        patchSystemHolidaySettingData,
        deleteSystemHolidaySettingData,
    }
}
export { useSystemHoliday }
